module.exports = __webpack_public_path__ + "img/ps_logo_pink.84b011af.svg";